export var ModuleInteraction;
(function (ModuleInteraction) {
    ModuleInteraction["None"] = "None";
    ModuleInteraction["RollOver"] = "RollOver";
    ModuleInteraction["SingleSliding"] = "SingleSliding";
    ModuleInteraction["Zoom"] = "Zoom";
    ModuleInteraction["ZoomSliding"] = "ZoomSliding";
})(ModuleInteraction || (ModuleInteraction = {}));
export var TActState;
(function (TActState) {
    TActState["UnkonwnActState"] = "UnkonwnActState";
    TActState["ComingSoon"] = "ComingSoon";
    TActState["OnGoing"] = "OnGoing";
    TActState["Ended"] = "Ended";
})(TActState || (TActState = {}));
export var CouponType;
(function (CouponType) {
    CouponType["CopyCoupon"] = "CopyCoupon";
    CouponType["ReceiveCoupon"] = "ReceiveCoupon";
})(CouponType || (CouponType = {}));
